<template>
  <div class="items main-content">
    <div class="page-header">
      <div class="d-flex flex-row">
        <div>
          <h3 class="page-title">{{ $tc("actions.list_of_actions") }}</h3>
        </div>
      </div>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="dashboard">{{
            $t("general.home")
          }}</router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="#">
            {{ $tc("actions.list_of_actions") }}</router-link
          >
        </li>
      </ol>
    </div>
    <div
      v-cloak
      v-show="showEmptyScreen"
      class="col-xs-1 no-data-info"
      align="center"
    >
      <satellite-icon class="mt-5 mb-4" />
      <div class="row" align="center">
        <label class="col title">{{ $t("actions.no_action") }}</label>
      </div>
      <div class="row">
        <label class="description col mt-1" align="center">{{
          $t("actions.list_of_action")
        }}</label>
      </div>
    </div>

    <div v-show="!showEmptyScreen" class="table-container">
      <div class="table-actions mt-5">
        <p class="table-stats">
          {{ $t("general.showing") }}: <b>{{ emailActions.length }}</b>
          {{ $t("general.of") }} <b>{{ totalEmailActions }}</b>
        </p>
      </div>
      <div class="custom-control custom-checkbox">
        <input
          id="select-all"
          v-model="selectAllFieldStatus"
          type="checkbox"
          class="custom-control-input"
          @change="selectAllEmailActions"
        />
        <label
          v-show="!isRequestOngoing"
          for="select-all"
          class="custom-control-label selectall"
        >
          <span class="select-all-label">{{ $t("general.select_all") }} </span>
        </label>
      </div>
      <table-component
        ref="table"
        :data="fetchData"
        :show-filter="false"
        table-class="table"
      >
        <table-column
          :sortable="false"
          :filterable="false"
          cell-class="no-click"
        >
          <template slot-scope="row">
            <div class="custom-control custom-checkbox">
              <input
                :id="row.id"
                v-model="selectField"
                :value="row.id"
                type="checkbox"
                class="custom-control-input"
              />
              <label :for="row.id" class="custom-control-label" />
            </div>
          </template>
        </table-column>
        <table-column :label="$t('actions.name')" show="name" />
        <table-column :label="$t('actions.updated_at')" show="updated_at" />

        <table-column
          :sortable="false"
          :filterable="false"
          cell-class="action-dropdown"
        >
          <template slot-scope="row">
            <v-dropdown>
              <a slot="activator" href="#">
                <dot-icon />
              </a>
              <v-dropdown-item>
                <router-link
                  :to="{ path: `emailAction/${row.id}/placeholders` }"
                  class="dropdown-item"
                >
                  <font-awesome-icon
                    :icon="['fas', 'clone']"
                    class="dropdown-item-icon"
                  />
                  {{ $t("actions.placeholders") }}
                </router-link>
              </v-dropdown-item>
            </v-dropdown>
          </template>
        </table-column>
      </table-component>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DotIcon from "../../components/icon/DotIcon";
import SatelliteIcon from "../../components/icon/SatelliteIcon";
import BaseButton from "../../../js/components/base/BaseButton";

export default {
  components: {
    DotIcon,
    SatelliteIcon,
    BaseButton
  },
  data() {
    return {
      id: null,
      showFilters: false,
      isRequestOngoing: true,
      filtersApplied: false
    };
  },

  computed: {
    ...mapGetters("emailActionList", [
      "totalEmailActions",
      "emailActions",
      "selectAllField",
      "selectedEmailActions"
    ]),
    showEmptyScreen() {
      return (
        !this.emailActions && !this.isRequestOngoing && !this.filtersApplied
      );
    },
    filterIcon() {
      return this.showFilters ? "times" : "filter";
    },
    selectField: {
      get: function() {
        return this.selectedEmailActions;
      },
      set: function(val) {
        this.selectEmailAction(val);
      }
    },
    selectAllFieldStatus: {
      get: function() {
        return this.selectAllField;
      },
      set: function(val) {
        this.setSelectAllState(val);
      }
    }
  },

  watch: {
    filters: {
      handler: "setFilters",
      deep: true
    }
  },
  created() {},
  destroyed() {
    if (this.selectAllField) {
      this.selectAllEmailActions();
    }
  },
  methods: {
    ...mapActions("emailActionList", [
      "fetchEmailActions",
      "selectAllEmailActions",
      "selectEmailAction",
      "setSelectAllState"
    ]),
    ...mapActions("modal", ["openModal"]),
    refreshTable() {
      this.$refs.table.refresh();
    },
    async fetchData({ page, per_page, filter, sort }) {
      this.isRequestOngoing = true;
      let response = await this.fetchEmailActions({ page, per_page });
      this.isRequestOngoing = false;

      return {
        data: response.data.data.data,
        pagination: {
          totalPages: response.data.data.last_page,
          currentPage: page,
          rowsPerPage: response.data.data.per_page // Add rowsPerPage in the API request
        }
      };
    },
    setFilters() {
      this.filtersApplied = true;
      this.refreshTable();
    },
    clearFilter() {
      this.filters = {
        name: "",
        part_number: "",
        unit: "",
        price: ""
      };

      this.$nextTick(() => {
        this.filtersApplied = false;
      });
    },
    toggleFilter() {
      if (this.showFilters && this.filtersApplied) {
        this.clearFilter();
        this.refreshTable();
      }
      this.showFilters = !this.showFilters;
    }
  }
};
</script>
